import { Container, Timeline, Line, Dot, Content } from './TimelineItem.styles'

export type TimelinePosition = 'first' | 'middle' | 'last'

export type TimelineItemProps = {
  /** Content to be rendered for the item */
  children?: React.ReactNode

  /** If true will not render the dot for the item */
  dotless?: boolean

  /** The position whithin the Timeline will determine it's style */
  position: TimelinePosition
}

export function TimelineItem({ children, dotless = false, position }: TimelineItemProps) {
  return (
    <Container>
      <Timeline position={position}>
        <Line position={position}>{!dotless && <Dot data-testid="dot" />}</Line>
      </Timeline>
      <Content position={position}>{children}</Content>
    </Container>
  )
}
